import { Component, Input } from '@angular/core';

@Component({
  selector: 'getm-left-label-card',
  templateUrl: './left-label-card.component.html',
  styleUrls: ['./left-label-card.component.scss'],
})
export class LeftLabelCardComponent {

  @Input() icon: string = '';
  @Input() iconColor: string = 'getm-primary-default';
  @Input() text: string = '';
  @Input() textColor: string = 'getm-neutral-light';
  @Input() colorBg: string = 'getm-information-light';

  constructor() { }

}
